import { useState } from "react";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import Layout from "../assets/component/Layout";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL

export default function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [apiError, setApiError] = useState("");
  const [apiSuccess, setApiSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page refresh
    setApiError("");
    setApiSuccess("");

    try {
      const response = await axios.post(`${BASE_URL}forgot-password`, { email });

      if (response.status === 200) {
        setApiSuccess("Password reset link sent successfully.");
        navigate("/home");
      } else {
        setApiError("Failed to send reset email.");
      }
    } catch (error) {
      setApiError(error.response?.data?.message || "Something went wrong. Try again.");
    }
  };

  return (
    <Layout>
      <section className="login-layout">
        <div className="main-login-form">
          <h1>Forgot Password</h1>
          <p>Enter your email address to reset your password.</p>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-5" controlId="formBasicEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            {apiError && <p style={{ color: "red" }}>{apiError}</p>}
            {apiSuccess && <p style={{ color: "green" }}>{apiSuccess}</p>}

            <button type="submit">Submit</button>
          </Form>
        </div>
      </section>
    </Layout>
  );
}
